import i18n from 'i18next'
import Backend from 'i18next-xhr-backend'
import { initReactI18next } from 'react-i18next'
import { LocalStorageService } from './services'

const localStorageService = new LocalStorageService()

let userLanguage = localStorageService.getLocalStorageItem("preferredLanguage") || 'es'

i18n
  .use(Backend)
  .use(initReactI18next)
  .init({
    lng: userLanguage,
    backend: {
      loadPath: '/assets/i18n/{{ns}}/{{lng}}.json'
    },
    fallbackLng: 'es',
    debug: false,
    ns: ['translations'],
    defaultNS: 'translations',
    keySeparator: false,
    interpolation: {
      escapeValue: false,
      formatSeparator: ','
    },
    react: {
      wait: true,
      useSuspense: false
    }
  })

export default i18n